module.exports = __webpack_public_path__ + "img/401620edb824d10729a4b5fabc3d936b.33818a19.png";